/**
 * Format ISO date string to human-readable relative time
 * e.g. "剛剛", "3 分鐘前", "2 小時前", "5 天前", "2 個月前", "2025-04-08"
 */
export const formatDate = (iso) => {
  if (!iso) return '';

  const now = new Date();
  const d = new Date(iso);
  const diff = Math.floor((now - d) / 1000);

  if (diff < 60) return '剛剛';
  if (diff < 3600) return `${Math.floor(diff / 60)} 分鐘前`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} 小時前`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)} 天前`;
  if (diff < 31536000) return `${Math.floor(diff / 2592000)} 個月前`;

  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
